"use client"

import { ConciergeBell } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ConciergeBellIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ConciergeBellIcon = component(Icon)({ as: ConciergeBell })
